export const WisDetailsModalDivider = () => (
  <hr className='border-gray-100 border-t-8 mb-4' />
)

export default WisDetailsModalDivider
